/* unplugin-vue-components disabled */import script from "./addDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./addDrawer.vue?vue&type=script&setup=true&lang=js"

import "./addDrawer.vue?vue&type=style&index=0&id=a8654fa4&lang=less&scoped=true"
import "./addDrawer.vue?vue&type=style&index=1&id=a8654fa4&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a8654fa4"]])

export default __exports__